<template>
    <div></div>
</template>
<script>
    import axios from 'axios'
    import AuthenticationService from "@/services/AuthenticationService";
    export default {
        mounted() {
            if(this.$route.query.t !== undefined) {
                let redirect = this.$route.query.redirect
                let data = {
                    token: this.$route.query.t
                }
                let that = this
                
                AuthenticationService.apilogin(data)
                .then((res) => {
                    if(res.data.result == true) {
                        window.location = redirect;
                    } else {
                        that.$router.push("login");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }
        }
    }
</script>
